/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ToolPencilIcon16Solid = forwardRef('ToolPencilIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M2 13.5v-2.086a1 1 0 0 1 .293-.707l7.145-7.145 3 3-7.145 7.145a1 1 0 0 1-.707.293H2.5a.5.5 0 0 1-.5-.5Z" }),
        React.createElement("path", { d: "m13.51 5.49 1.07-1.07a1.3 1.3 0 0 0 0-1.84l-1.16-1.16a1.3 1.3 0 0 0-1.84 0l-1.07 1.07 3 3Z" })));
});
